export default __webpack_public_path__ + "static/media/footerPhone.76ff4d69.png";